import { render } from "./DepositsNotSent.vue?vue&type=template&id=53b304e4&scoped=true"
import script from "./DepositsNotSent.vue?vue&type=script&lang=js"
export * from "./DepositsNotSent.vue?vue&type=script&lang=js"

import "./DepositsNotSent.vue?vue&type=style&index=0&id=53b304e4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b304e4"]])

export default __exports__